// src/store/system/actions.ts

import { AGREE_TO_TERMS, SystemActionTypes } from './types';

export function agreeToTerms(): SystemActionTypes {
    return {
        type: AGREE_TO_TERMS,
    };
}
